import React, { Fragment, useEffect, useState } from 'react';
import animationFunction from '../Common/animationFunction';
import { useLocale } from '../../localization/LocaleContext';
const data = [

    {
        id:1,
        planKey: 'free',
        price:0,
        yearlyPrice:0,
        features:[
            {
                id:0,
                img:"/images/Group65.png",
                featureKey:'oneAiEstimate'
            },
            {
                id:1,
                img:"/images/Group65.png",
                featureKey:'fiveInvoices'
            },
            {
                id:2,
                img:"/images/Group65.png",
                featureKey:'fiveClients'
            },
            {
                id:3,
                img:"/images/Group65.png",
                featureKey:'twentyItems'
            },
            {
                id:4,
                img:"/images/Group65.png",
                featureKey:'twentyExpenses'
            },
            {
                id:5,
                img:"/images/Group65.png",
                featureKey:'twentyTimeTrackings'
            },
            {
                id:6,
                img:"/images/Group65.png",
                featureKey:'invoiceStatusTracking'
            },
            {
                id:7,
                img:"/images/Group65.png",
                featureKey:'clientActivity'
            },
        ]
    },
    {
        id:2,
        planKey: 'premium',
        price:19.99,
        yearlyPrice:200,
        features:[
            {
                id:0,
                img:"/images/Group65.png",
                featureKey:'fiveAiEstimates'
            },
            {
                id:1,
                img:"/images/Group65.png",
                featureKey:'unlimitedDocuments'
            },
            {
                id:2,
                img:"/images/Group65.png",
                featureKey:'unlimitedClients'
            },
            {
                id:3,
                img:"/images/Group65.png",
                featureKey:'unlimitedItems'
            },
            {
                id:4,
                img:"/images/Group65.png",
                featureKey:'unlimitedExpenses'
            },
            {
                id:5,
                img:"/images/Group65.png",
                featureKey:'unlimitedTimeTrackings'
            },
            {
                id:6,
                img:"/images/Group65.png",
                featureKey:'emailReminders'
            },
            {
                id:7,
                img:"/images/Group65.png",
                featureKey:'reports'
            },
            {
                id:8,
                img:"/images/Group65.png",
                featureKey:'exportCsv'
            },
        ]
    },
    {
        id:3,
        planKey: 'ultimate',
        price:29.99,
        yearlyPrice:300,
        features:[
            {
                id:0,
                img:"/images/Group65.png",
                featureKey:'fiftyAiEstimates'
            },
            {
                id:1,
                img:"/images/Group65.png",
                featureKey:'everythingUnlimited'
            },
            {
                id:2,
                img:"/images/Group65.png",
                featureKey:'priorityAi'
            },
            {
                id:3,
                img:"/images/Group65.png",
                featureKey:'detailedAnalytics'
            },
            {
                id:4,
                img:"/images/Group65.png",
                featureKey:'whiteLabeling'
            },
            {
                id:5,
                img:"/images/Group65.png",
                featureKey:'emailReminders'
            },
            {
                id:6,
                img:"/images/Group65.png",
                featureKey:'reports'
            },
            {
                id:7,
                img:"/images/Group65.png",
                featureKey:'exportCsv'
            },
        ]
    },
    
]


function PlanBox(){
    const { t } = useLocale();
    const [yearly, setYearly] = useState(false);

    useEffect(() => {
        animationFunction('planBox')
    }, [])
    return(
        <Fragment>
            <div className="col-12 d-flex justify-content-center mb-30">
                <div className="pricing-toggle">
                    <span className={!yearly ? 'pricing-toggle-active' : ''}>{t('pricing.monthly')}</span>
                    <button className="pricing-toggle-switch" onClick={() => setYearly(!yearly)} aria-label="Toggle yearly pricing">
                        <span className={`pricing-toggle-knob${yearly ? ' pricing-toggle-knob-right' : ''}`} />
                    </button>
                    <span className={yearly ? 'pricing-toggle-active' : ''}>
                        {t('pricing.yearly')}
                        <span className="pricing-toggle-save">{t('pricing.saveLabel')}</span>
                    </span>
                </div>
            </div>
            {data.map((i => (
                <div className="col-lg-4" key={i.id}>
                <div className={`planBox mb-20 p-30 br-8${i.planKey === 'premium' ? ' planBox-popular' : ''}`}>
                        {i.planKey === 'premium' && (
                            <span className="planBox-popular-badge">{t('pricing.mostPopular')}</span>
                        )}
                        <h6 className="h-6 mb-15 fw-300">
                            {t(`pricing.plans.${i.planKey}.name`)}
                        </h6>
                        {i.price === 0 ? (
                            <h3 className="h-3 fw-400 mb-15">
                                {t('pricing.free')}
                            </h3>
                        ) : (
                            <h3 className="h-3 fw-400 mb-15">
                                €{yearly ? i.yearlyPrice : i.price} <span className="planMonth">{yearly ? t('pricing.yearLabel') : t('pricing.monthLabel')}</span>
                            </h3>
                        )}
                        <p className="planPara">
                            {t(`pricing.plans.${i.planKey}.description`)}
                        </p>
                        {i.features.map((k => {
                            return(
                                <div className="mb-15 flex-simple-center planBox-option" key={k.id}>
                                    <img className="planBox-tick" src={k.img} alt="img" />
                                    <p className="planBox-text ml-10">
                                        {t(`pricing.features.${k.featureKey}`)}
                                    </p>
                                </div>
                            )
                        }))}
                        <div className="flex-center-align flex-column">
                            <button className="planBox-btn br-5 mt-20">
                                {i.price === 0 ? t('pricing.getStarted') : t('pricing.tryNow')}
                            </button>
                        </div>
                </div>
            </div>
            )))}
        </Fragment>
    )
}

export default PlanBox;